import api from "../src/services/usersAndGroups"
import { mapState, mapActions } from "vuex";
export default {
    data() {
      return {
        bulk_delete_ids: []
      };
    },

    computed: {
        ...mapState("CommonStore", ["companyData"]),
        ...mapState("UsersAndGroups", ["allUserGroups", "get_user_groups_loading"]),
        computeAllUsersGroup: {
            get() {
                return this.allUserGroups.map(item => ({
                    ...item,
                    is_selected: false
                })).filter(item =>
                    item.name.toLowerCase().includes(this.search_user_group.toLowerCase())
                );
            },
            set(newValue) {
                this.allUserGroups = newValue;
            }
        }  
    },
    watch:{
        companyData(newVal, oldVal){
            // if(Object.keys(newVal).length){
            //     this.getUserGroupsAction({store_id: null});
            // }
        }
    },
    created() {
    },
    mounted() {
        // this.getUserGroupsAction({store_id: this.companyData.id});
        // this.getUserGroupsAction({store_id: '3424ebf6-cc68-4aa0-9d81-588a2008dd11' /* this.companyData.id */ });
    },
    
    methods: {
        ...mapActions("UsersAndGroups", ["getUserGroupsAction", "deleteGroupAction"]),
        redirectToUi(url) {
			this.$router.push(url).catch(()=>{});
		},
        editGroup(item) {
			this.$router.push('/user-group/edit/'+item.id).catch(()=>{});
		},
        selectAllGroups(){
            this.computeAllUsersGroup.map((group)=>{
                group.is_selected = this.select_all_user_groups;
                if(this.select_all_user_groups){ this.bulk_delete_ids.push(group.id) } else { this.bulk_delete_ids = [] }
            });
        },
        selectRecord(condition, id){
            this.$forceUpdate();
            if(condition) { 
                this.bulk_delete_ids.push(id);
            } else { 
                // remove if unselected
                const index = this.bulk_delete_ids.indexOf(id);
                if (index !== -1) {
                  this.bulk_delete_ids.splice(index, 1);
                }
                if(this.bulk_delete_ids.length === 0){ this.select_all_user_groups = false }
             }
        },
        bulkGroupsDelete(){

        },
        deleteGroup(id) {
            this.$confirm('Do you want to delete user group?', 'Confirm', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                customClass: 'ns-confirm-box'
            })
                .then(() => {
                    let ids = [];
                    ids.push(id);
                    this.deleteGroupAction({ids});
                })
                .catch(action => {
                     
                });
		},
        bulkGroupsDelete() {
            this.$confirm('Do you want to delete selected user groups?', 'Confirm', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                customClass: 'ns-confirm-box'
            })
                .then(() => {
                    this.deleteGroupAction({ids: this.bulk_delete_ids});
                    this.bulk_delete_ids = [];
                })
                .catch(action => {
                     
                });
		},
        groupBy(id){
            let tags = [];
            let data = [...this.allUserGroups];
            data = data.find((e)=>e.id === id);
            if (data) {
                if (data.department.length) tags.push('department');
                if (data.employee_type.length) tags.push('employee type');
                if (data.functions.length) tags.push('functions');
                if (data.gender.length) tags.push('gender');
                if (data.user_access.length) tags.push('user access');
                if (data.user.length) tags.push('user');
              }
            return tags
        }
    }
  };
  